var exports = {
  "kL": "Tabs.module__container___UEFnNE",
  "Mf": "Tabs.module__tab___UEFnNE",
  "wH": "Tabs.module__selected___UEFnNE",
};

module.exports = exports;
